
<div class="modal-content">
  <div class="modal-header" id="social-share-btns-modal-header">
        <h5 class="modal-title" title="select-exam">Stories</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal('')">
          <span aria-hidden="true">&times;</span>
        </button>
  </div>
  <div class="modal-body">
      <div class="modal-info" id="stories-body">

  <div class="sto-leftbar">
    <div class="sto-side-scroller pt-0" style="    height: 55vh;
    padding: 15px 15px 15px 15px;">
        <!-- <h3 class="font-avbold mt-0 font-28">Stories</h3> -->


        <div class="chat-main-box sto-list">

            <div class="chat-left-aside">

                <div class="chat-left-inner inbchat-listscroll">
                    <ul class="chatonline style-none ps ps--theme_default ps--active-y">

                        <h4 class="mt-3 font-20" *ngIf="!hideYourStoriesPanel">Your Story</h4>
                        <li *ngIf="!hideYourStoriesPanel">
                          <ng-container *ngFor="let story of myStories; index as ind">
                            <li>
                              <a (click)="myStoryClick(story,ind)" [ngClass]="(myActiveIndex == ind && isMyStoryView) ? 'active' : ''" >
                                  <div class="media">
                                    <ng-container *ngIf="story.user_image">
                                      <img src="{{story.user_image}}" alt="icon" class="img-circle"  >
                                    </ng-container>
                                    <ng-container *ngIf="!story.user_image && story.customProfileName">
                                      <div class="img-circle profile-icon profile-name-icon"  style="background: {{story.colorPick}};     height: 54px !important;">{{story.customProfileName}}</div>
                                    </ng-container>
                                    <ng-container *ngIf="!story.user_image && !story.customProfileName">
                                      <div class="img-circle profile-icon profile-name-icon" style="background: {{story.colorPick}};      height: 54px !important;">G</div>
                                    </ng-container>
                                    <ng-template #customName>

                                    </ng-template>

                                      <div class="media-body">
                                        <ng-container *ngIf="story.story_desc">
                                          <div class="pl-2 m-0 text-body font-avbold align-items-center" style="white-space: nowrap;overflow: hidden;
                                          text-overflow: ellipsis;">
                                            {{story.story_desc}}
                                        </div>
                                        </ng-container>
                                        <ng-container *ngIf="!story.story_desc">
                                          <div class="pl-2 m-0 text-body font-avbold d-flex justify-content-between align-items-center">
                                            No Title added
                                        </div>
                                        </ng-container>
                                          <div class="pl-2 text-dark small text-ellipsis">{{story.date}}</div>
                                      </div>
                                  </div>
                              </a>
                          </li>
                          </ng-container>

                          <div *ngIf="!myScrollDisable && showMyStoryLoader" class="discuss-spinner">
                            <div intersectionObserver [intersectionDebounce]="0" (visibilityChange)="onMyStoryPanelVisibilityChanged(0, $event)">
                              <mat-spinner diameter="50"></mat-spinner>
                            </div>
                          </div>

                          <div *ngIf="myStories && myStories.length == 0 && !myloader">
                            <div class="no-records-found" style="padding: 25px;">
                                <div style="font-size: 14px;">No Stories Found, Please create your own story</div>
                            </div>
                          </div>
                        </li>
                        <hr style="background:#dee2e6;" *ngIf="!hideYourStoriesPanel">
                        <h4 class="mt-3 font-20">All Story</h4>

                      <ng-container *ngFor="let story of stories; index as ind">
                        <li>
                          <a (click)="storyClick(story,ind)" [ngClass]="(activeIndex == ind && !isMyStoryView) ? 'active' : ''" >
                              <div class="media">

                                <ng-container *ngIf="story.user_image">
                                  <img src="{{story.user_image}}" alt="icon" class="img-circle" [ngClass]="story.isViewedStory ? 'viewed-story' : 'new'" >
                                </ng-container>
                                <ng-container *ngIf="!story.user_image && story.customProfileName">
                                  <div class="img-circle profile-icon profile-name-icon" [ngClass]="story.isViewedStory ? 'viewed-story' : 'new'" style="background: {{story.colorPick}};">{{story.customProfileName}}</div>
                                </ng-container>
                                <ng-container *ngIf="!story.user_image && !story.customProfileName">
                                  <div class="img-circle profile-icon profile-name-icon" [ngClass]="story.isViewedStory ? 'viewed-story' : 'new'" style="background: {{story.colorPick}};">G</div>
                                </ng-container>
                                <ng-template #customName>

                                </ng-template>

                                <span [ngClass]="story.isViewedStory ? 'seen-tag' : 'hide-seen-tag'">Seen</span>

                                  <div class="media-body pl-3">
                                      <div class="pl-2 m-0 text-body font-avbold align-items-center" style="overflow: hidden;
                                      text-overflow: ellipsis; ">
                                          {{story.name}}
                                      </div>
                                      <div class="pl-2 text-dark small text-ellipsis">{{story.date}}</div>
                                  </div>
                              </div>
                          </a>
                      </li>
                      </ng-container>

                      <div *ngIf="!scrollDisable && showAllStoryLoader" class="discuss-spinner">
                        <div intersectionObserver [intersectionDebounce]="0" (visibilityChange)="onPanelVisibilityChanged(0, $event)">
                          <mat-spinner diameter="50"></mat-spinner>
                        </div>
                      </div>

                      <div *ngIf="stories && stories.length == 0 && !loader">
                        <div class="no-records-found" style="padding: 25px;">
                          <div style="font-size: 14px;">No Stories Found, Please come Back later</div>
                      </div>
                      </div>

                        <li class="p-20"></li>
                    </ul>
                </div>

            </div>

        </div>


    </div>

     <div class=" bg-white py-2">
          <a href="javascript:void(0)" (click)="openStoryPopup()" class="btn btn-pink-gradiant btn-next w-100 mr-2" style="color:white;"><img src="assets/images/plus.svg" class="mr-2 mt-n1" alt="plus icon"> Create a Story</a>
      </div>
</div>
      <div class="row mt-3">
          <div class="col-12 text-right">
              <button class="btn btn-pink-gradiant btn-next" data-dismiss="modal" data-target="#select-subject-post" (click)="closeModal('')" data-toggle="modal">Close</button>
          </div>
      </div>

      </div>
      <!-- BODY Of POPUP ENDS -->
  </div>
</div>



